(function ($) {

    $(document).ready(function () {

        //XXX check the params for get_search_form() OR pll_home_url
        //$('.search-form').get(0).setAttribute('action', '/');

        // sliders

        // slick slider fr multiple post listing
        $('#posts-slider.slick-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
            autoplay: false,
            autoplaySpeed: 3000,
            dots: true,
            customPaging: function (slider, i) {
                // this would render "tabs"
                return '<span class="dot"></span>';
            },
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false
                }
            }]
        });

        $('#quotes-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 3000,
            dots: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });

        // toggle-footer-menu

        $("#toggle-footer-menu").click(function () {
            $("#menu-accilium-footer-1").toggle("fast");
            var $target = $('html,body');
            $target.animate({ scrollTop: $target.height() }, 1000);
        });

        $(".share-this-btn").click(function () {
            $(".share-this-btn ul").toggle("fast");
        });

        $(".archive-image").removeClass('ct-image-container');

    })
})(jQuery);
